import classes from './ChatWidget.module.scss'
import { IconBot, IconClose, IconExpand, IconMenu, IconMinus, IconRestore, IconStar } from './icons'

interface Props {
  expanded: boolean
  leftOpen: boolean
  rightOpen: boolean
  onToggleLeft: () => void
  onToggleRight: () => void
  onToggleExpand: () => void
  onMinimize: () => void
  onClose: () => void
}

export default function ChatHeader({
  expanded,
  leftOpen,
  rightOpen,
  onToggleLeft,
  onToggleRight,
  onToggleExpand,
  onMinimize,
  onClose,
}: Props) {
  return (
    <div className={classes.header}>
      <button
        type='button'
        className={`${classes.iconBtn} ${classes.tipBottom}`}
        data-tip='Sohbet geçmişi'
        aria-label='Sohbet geçmişi'
        aria-expanded={leftOpen}
        onClick={onToggleLeft}
      >
        <IconMenu />
      </button>

      <div className={classes.avatarWrap}>
        <div className={classes.avatar}>
          <IconBot />
        </div>
        <span className={classes.onlineDot} aria-hidden='true' />
      </div>

      <div className={classes.headerInfo}>
        <div className={classes.title}>B-Gini</div>
        <div className={classes.status}>Çevrimiçi</div>
      </div>

      <div className={classes.headerActions}>
        <button
          type='button'
          className={`${classes.iconBtn} ${classes.iconBtnStar} ${classes.tipBottom}`}
          data-tip='Hızlı bağlantılar'
          aria-label='Hızlı bağlantılar'
          aria-expanded={rightOpen}
          onClick={onToggleRight}
        >
          <IconStar />
        </button>
        <button
          type='button'
          className={`${classes.iconBtn} ${classes.tipBottom}`}
          data-tip='Simge durumuna küçült'
          aria-label='Simge durumuna küçült'
          onClick={onMinimize}
        >
          <IconMinus />
        </button>
        <button
          type='button'
          className={`${classes.iconBtn} ${classes.expandBtn} ${classes.tipBottom}`}
          data-tip={expanded ? 'Küçült' : 'Tam boyut'}
          aria-label={expanded ? 'Küçült' : 'Tam boyut'}
          onClick={onToggleExpand}
        >
          {expanded ? <IconRestore /> : <IconExpand />}
        </button>
        <button
          type='button'
          className={`${classes.iconBtn} ${classes.iconBtnDanger} ${classes.tipBottom}`}
          data-tip='Kapat'
          aria-label='Kapat'
          onClick={onClose}
        >
          <IconClose />
        </button>
      </div>
    </div>
  )
}
